<ngx-charts-gauge
  [results]="chartData"
  [scheme]="colorScheme"
  [customColors]="customColors"
  [showAxis]="showXAxis"
  [legend]="showLegend && cardSize === CardSize.LARGE"
  [animations]="true"
  [tooltipDisabled]="false"
  (select)="onSelect($event)"
  [valueFormatting]="valueFormatting"
  class="w-full h-full"
></ngx-charts-gauge>
